import './public-path'
import Vue from 'vue'
import App from './App.vue'
import JtechWebComps from 'jtech-webcomps'
import Styles from './styles/quasar.styl'
import router from './router'
import translations from '../locales'
import { Auth, Http, JtKeyUp, Axios, Mobx, Echarts, StringLocaleBr } from './plugins'
import { crud, repository, state, messageBox } from './jtech'
import { JtechMessage } from './plugins/system.messages'
import JtechWebExceptions from 'jtech-web-exceptions'
import PersonSearch from './components/input/person-search/PersonSearch'
import GeneratorSearch from './components/input/generator-search/GeneratorSearch'
import CarrierSearch from './components/input/carrier-search/CarrierSearch'
import CadriSearch from './components/input/cadri-page/CadriSearch.vue'

Vue.use(Echarts)
Vue.use(Mobx)
Vue.use(Http, {
  router
})
Vue.use(StringLocaleBr)
Vue.use(Auth)
Vue.use(JtKeyUp)
Vue.use(Axios)
Vue.use(JtechWebExceptions, {
  message: JtechMessage
})

Vue.use(JtechWebComps, {
  getTextConfig: {
    availableLanguages: {
      // eslint-disable-next-line
      en_US: "American English",
      // eslint-disable-next-line
      pt_BR: "Português (Brasil)",
      es: 'Espanol'
    },
    defaultLanguage: 'pt_BR',
    languageVmMixin: {
      computed: {
        currentKebabCase: function () {
          return this.current.toLowerCase().replace('_', '-')
        }
      }
    },
    translations,
    silent: true
  },
  jtech: {
    crud,
    repository,
    state,
    messageBox,
    components: {
      jtDataTable: {
        separator: 'horizontal',
        bordered: false
      },
      jtInput: {
        outlined: true
      },
      jtDynamicForm: {
        customElements: {
          person_search: PersonSearch,
          generator_search: GeneratorSearch,
          carrier_search: CarrierSearch,
          cadri_search: CadriSearch
        }
      }
    }
  }
})

function textDouble (texto) {
  if (texto) {
    texto = texto.replace(/\D/g, '')
    texto = texto.replace(/^0+/, '')

    const tamanhoTexto = texto.length

    if (tamanhoTexto > 5) {
      const textoInteiro = texto.slice(0, -2)
      const textoDecimal = texto.slice(-2)
      texto = textoInteiro.split('').reverse().join('').replace(/(\d{3})/g, '$1.').split('').reverse().join('').replace(/^\./, '')
      texto = texto + ',' + textoDecimal
    } else {
      texto = texto.padStart(3, '0')
      const textoInteiro = texto.slice(0, -2)
      const textoDecimal = texto.slice(-2)
      texto = textoInteiro + ',' + textoDecimal
    }

    return texto
  }
}

Vue.directive('jtech-text-double', (el, binding) => {
  const texto = el.innerHTML
  if (texto) {
    const textResult = textDouble(texto)
    el.innerHTML = (binding.value && binding.value == 'currency') ? 'R$ ' + textResult : textResult
  }
})

export const busBillingOrderExportReport = new Vue()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
